import { ReactNode } from 'react'
import { usePermissions } from '~/entities/common/viewer'
import { canShowObject } from '~/shared/lib/utils'
import { Tabs, Tab } from '~/shared/ui/RoutesTabs/type'
import { AddCarLicenseePage } from './CarLicensee/AddCarLicenseePage'
import { EditCarLicenseePage } from './CarLicensee/EditCarLicenseePage'
import { ListCarLicenseePage } from './CarLicensee/ListCarLicenseePage'

type UseConfigTabsProps = {
  listCarRentalPage: ReactNode
  addCarRentalPage: ReactNode
  editCarRentalPage: ReactNode
}

export const useConfigTabs = ({
  listCarRentalPage,
  addCarRentalPage,
  editCarRentalPage,
}: UseConfigTabsProps): Tabs => {
  const { canViewCarRentals, canViewCarLicensees } = usePermissions()

  return [
    ...canShowObject<Tab>(canViewCarRentals, {
      labelI18n: 'lessors',
      path: '/car-rentals',
      content: listCarRentalPage,
      children: [
        {
          path: '/new',
          content: addCarRentalPage,
          full: true,
        },
        {
          path: '/:carRentalId',
          content: editCarRentalPage,
          full: true,
        },
      ],
    }),
    ...canShowObject<Tab>(canViewCarLicensees, {
      labelI18n: 'licensees',
      path: '/car-licensees',
      content: <ListCarLicenseePage />,
      children: [
        {
          path: '/new',
          content: <AddCarLicenseePage />,
          full: true,
        },
        {
          path: '/:carLicenseeId/*',
          content: <EditCarLicenseePage />,
          full: true,
        },
      ],
    }),
  ]
}
